export default __webpack_public_path__ + "static/media/about_me_1.bd6b441f.jpg";